<template>
  <div>
    <v-card>
      <v-card-title class="pa-0">
        <base-table-header
          @search="onSearch"
          :btnFilter="true"
          :btnAdd="$allow(`akun-${akses}.create`)"
          :btnDownload="
            akses === 'kelas' ? $allow(`akun-${akses}.download`) : $allow(`akun-${akses}.download-aktivasi`)
          "
          @add="onAdd"
          @reload="onReload"
          @filter="onFilter"
          @download="onDownload"
        >
          <template v-slot:toolbar>
            <template v-if="akses === 'pembimbing-praktik' && $allow('akun-pembimbing-praktik.set-status')">
              <v-menu bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" small color="info" class="ml-2 py-5"> set Pembimbing</v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="setMultiInti('inti')">
                    <v-list-item-content>
                      <v-list-item-title>Set Pembimbing Inti</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="setMultiInti('bimtek')">
                    <v-list-item-content>
                      <v-list-item-title>Set Keterangan BIMTEK</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template
              v-if="
                akses === 'pengajar' &&
                $allow(`akun-${akses === 'pengajar' ? 'pengajar' : 'pembimbing-praktik'}.set-status`)
              "
            >
              <v-menu :close-on-content-click="false" :nudge-width="200" offset-x offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" small color="info" class="ml-2 py-5"> Set Peran </v-btn>
                </template>
                <v-card>
                  <v-list>
                    <v-list-item @click="setMultiInti('inti_pengajar')">
                      <v-list-item-title>Pengajar Inti </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="setMultiInti('inti_pembimbing')">
                      <v-list-item-title>Pembimbing Inti </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="setMultiInti('is_bimtek_ppm')">
                      <v-list-item-title>Lulus Bimtek Pengajar</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="setMultiInti('is_bimtek_pptm')">
                      <v-list-item-title>Lulus Bimtek Pembimbing</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="setMultiInti('master')">
                      <v-list-item-title>Master</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="setMultiInti('tambahan')">
                      <v-list-item-title>Non Tambahan</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </template>
          </template>
          <template v-slot:subtitle>
            <div class="subtitle-1 black--text">
              <b>{{ total }} </b> Akun
            </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <base-list-filter
        ref="filter"
        title="Pilih Filter Status"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="filterStatus"
      />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <slot :item="item">
                <v-list-item dense class="px-0">
                  <v-list-item-content>
                    <v-row>
                      <v-col class="py-0" cols="12" :md="['pembimbing-praktik', 'pengajar'].includes(akses) ? 3 : 4">
                        <v-list-item class="px-0" @click="onDetail(item)">
                          <v-list-item-avatar color="primary">
                            <v-icon dark>mdi-account-circle</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content class="py-0 mt-3">
                            <div class="body-1 black--text">
                              <strong>{{ $getDeepObj(item, 'akun.data.nama') || '-' }}</strong>
                            </div>
                            <p class="caption black--text">
                              <span>Email: {{ $getDeepObj(item, 'akun.data.email') || '-' }}</span>
                            </p>
                            <p class="caption purple--text" v-if="Number(item.is_bimtek_ppm) === 1">
                              <v-icon small color="purple">mdi-check-circle</v-icon> Lulus Bimtek Pengajar
                            </p>
                            <p class="caption purple--text" v-if="Number(item.is_bimtek_pptm) === 1">
                              <v-icon small color="purple">mdi-check-circle</v-icon> Lulus Bimtek Pembimbing
                            </p>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col class="py-0" cols="12" :md="['pembimbing-praktik', 'pengajar'].includes(akses) ? 3 : 4">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0 mt-3">
                            <template v-if="$getDeepObj(item, 'instansi.data.nama')">
                              <span class="caption">Instansi</span>
                              <p>
                                <span>{{ $getDeepObj(item, 'instansi.data.nama') || '-' }}</span>
                              </p>
                            </template>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col class="py-0" cols="12" v-if="['pengajar'].includes(akses)" :md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0 mt-3">
                            <span class="caption">Kelas Diklat</span>
                            <div>
                              <v-chip
                                v-if="item.is_petugas_daring === 0 && item.is_petugas_luring === 0"
                                label
                                small
                                class="orange lighten-4 black--text"
                              >
                                Belum Pernah
                              </v-chip>
                              <v-chip v-if="item.is_petugas_daring" label small class="blue lighten-4 blue--text mb-1">
                                Diklat Daring
                              </v-chip>
                              <v-chip v-if="item.is_petugas_luring" label small class="green lighten-4 green--text">
                                Diklat Luring
                              </v-chip>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col class="py-0" cols="12" :md="['pembimbing-praktik', 'pengajar'].includes(akses) ? 2 : 2">
                        <v-list-item class="px-0">
                          <v-list-item-content>
                            <span class="caption">Status</span>
                            <div>
                              <v-chip
                                small
                                dark
                                :color="Number($getDeepObj(item, 'is_aktif')) === 1 ? 'success' : 'red'"
                              >
                                {{ Number($getDeepObj(item, 'is_aktif')) === 1 ? 'Aktif' : 'Tidak Aktif' }}
                              </v-chip>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <template
                        v-if="
                          ['pembimbing-praktik', 'pengajar'].includes(akses) &&
                          (Number($getDeepObj(item, 'is_inti_ppm') || 0) === 1 ||
                            Number($getDeepObj(item, 'is_inti_pptm') || 0) === 1 ||
                            Number($getDeepObj(item, 'is_master_ppm') || 0) === 1 ||
                            Number($getDeepObj(item, 'is_tambahan') || 0) === 1)
                        "
                      >
                        <v-col class="py-0" cols="12" md="2">
                          <v-list-item class="px-0">
                            <v-list-item-content>
                              <span class="caption">Peran</span>
                              <div>
                                <v-chip
                                  class="mr-2"
                                  small
                                  dark
                                  color="pink"
                                  v-if="Number($getDeepObj(item, 'is_inti_ppm') || 0) === 1"
                                  style="margin-top: 1pt"
                                >
                                  Pengajar Inti
                                </v-chip>
                                <v-chip
                                  class="mr-2"
                                  small
                                  dark
                                  color="pink"
                                  style="margin-top: 1pt"
                                  v-if="Number($getDeepObj(item, 'is_inti_pptm') || 0) === 1"
                                >
                                  Pembimbing Inti
                                </v-chip>
                                <v-chip
                                  small
                                  dark
                                  color="pink"
                                  v-if="Number($getDeepObj(item, 'is_master_ppm') || 0) === 1"
                                  style="margin-top: 1pt"
                                >
                                  Master
                                </v-chip>
                                <v-chip
                                  class="mx-1"
                                  small
                                  dark
                                  color="pink"
                                  v-if="Number($getDeepObj(item, 'is_tambahan') || 0) === 1"
                                  style="margin-top: 1pt"
                                >
                                  Tambahan
                                </v-chip>
                              </div>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                      </template>
                    </v-row>
                  </v-list-item-content>
                  <v-list-item-action-text>
                    <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                  </v-list-item-action-text>
                </v-list-item>
              </slot>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full
      ref="modal"
      colorBtn="primary"
      :lblBtn="formulir.lblBtn || `Simpan & Cetak`"
      generalError
      :use-save="formulir.isValid"
      :title="formulir.title"
      @save="onSave"
    >
      <component
        ref="formulir"
        :is="formulir.component || 'FormAkun'"
        :title="title"
        :isChecked="formulir.isChecked"
        :isEdit="formulir.isEdit"
        :initValue="formulir.init"
        :detail="formulir.detail"
        :errorEmail="formulir.errorEmail"
        :groups="groups"
        :instansis="instansis"
        :masters="masters"
        :jenis="jenis"
        :useUpload="$allow(`akun-${akses}.upload`)"
        @check="onCheck"
        @onValidate="onValidate"
        @onStep="
          () => {
            $set(formulir, 'isValid', false);
          }
        "
        @upload="onUpload"
        @unduhTemplate="unduhTemplate"
        @getInstansi="getInstansi"
      />
    </base-modal-full>
    <Akun ref="akun" :akun="akun" />
    <popup-upload
      ref="uploader"
      :rules="{ format: 'xls', required: true }"
      label-ok="pilih"
      format="XLXS/XLS"
      title="Data Akun"
      @save="setFile"
      @unduhTemplate="unduhTemplate"
    ></popup-upload>
    <popup-selector
      v-if="selector && selector.fetch"
      ref="selector"
      :title="selector && selector.title"
      :valueId="selector && selector.valueId"
      :fetch="selector && selector.fetch"
      :filterSelect="selector && selector.filters"
      :attr="selector && selector.attr"
      @save="onSaveInti"
    >
      <template slot-scope="{ item }">
        <v-list-item dense class="px-0">
          <v-list-item-content>
            <v-row>
              <v-col class="py-0" cols="12" md="6">
                <v-list-item class="px-0" @click="onDetail(item)">
                  <v-list-item-avatar color="primary">
                    <v-icon dark>mdi-account-circle</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 mt-3">
                    <div class="body-1 black--text">
                      <strong>{{ $getDeepObj(item, 'akun.data.nama') || '-' }}</strong>
                    </div>
                    <p class="caption black--text">
                      <span>Email: {{ $getDeepObj(item, 'akun.data.email') || '-' }}</span>
                    </p>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col class="py-0" cols="12" md="6">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0 mt-3">
                    <span class="caption">Instansi</span>
                    <p>
                      <span>{{ $getDeepObj(item, 'instansi.data.nama') || '-' }}</span>
                    </p>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </template>
    </popup-selector>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import FormAkun from '@views/instansi/akun/formulir/Akun';
import DetailView from './Detail';
import Akun from '@components/cetak/Akun';
import PopupUpload from '@components/popup/Upload';
import mixin from './mixin';
import list from '@mixins/list';
import { M_AKTIF } from '@utils/master';
import PopupSelector from '@components/popup/Selector';
export default {
  name: 'ListAdmin',
  props: {
    akses: {
      type: String,
      required: true,
    },
    jenis: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    desc: {
      type: String,
      default: '',
    },
    actions: {
      type: Array,
      required: true,
    },
    paramsTipe: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [list, mixin],
  components: { PopupSelector, DetailView, FormAkun, Akun, PopupUpload },
  data() {
    return {
      formulir: {},
      selector: {},
      selected: [],
      akun: {},
      groups: {},
      instansis: {},
      initInstansis: {},
      menu: false,
    };
  },
  mounted() {
    // filter
    Object.assign(this.filters, {
      k_group: this.$route.meta && this.$route.meta.k_group,
    });

    Object.assign(this.attr, {
      tipe: this.$route.meta && this.$route.meta.tipe,
    });

    Object.assign(this.params, this.paramsTipe);
  },
  computed: {
    ...mapState('master', {
      masters: (state) => (state && state.masters) || {},
    }),

    mAktif() {
      let temp = {};
      for (const item of M_AKTIF) {
        temp[item.value] = item.text;
      }
      return temp;
    },

    configs() {
      const M_PROPINSI = this.masters.m_propinsi || {};
      const M_KOTA = this.masters.m_kota || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: [false, false],
        label: ['Provinsi', 'Kota/Kabupaten'],
        options: [M_PROPINSI, M_KOTA],
        grid: [{ cols: 12 }, { cols: 12 }],
        disabled: [],
      };
    },

    formFilter() {
      let temp = [
        {
          label: 'Pilih Status',
          default: true,
          type: 'radio',
          model: 'is_aktif',
          master: M_AKTIF,
          grid: { cols: 6 },
        },
      ];

      if (['program', 'admin_gtk'].includes(this.jenis)) {
        temp.push({
          label: 'Nama Instansi',
          model: 'instansi_id',
          type: 'select',
          default: false,
          props: ['attach'],
          master: this.$mapForMaster(this.initInstansis || {}),
          labelColor: 'secondary',
          grid: { cols: 6 },
        });
      }

      if (['pengajar', 'pembimbing'].includes(this.jenis)) {
        temp.push({
          label: 'Lokasi',
          default: true,
          type: 'cascade',
          configs: this.configs,
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        });

        temp.push({
          label: 'Jenis Sertifikat Diklat',
          model: 'k_diklat_paud',
          type: 'select',
          default: false,
          props: ['attach'],
          master: this.$mapForMaster(this.masters.m_diklat_paud || {}),
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        });

        temp.push({
          label: 'Tingkat Sertifikat Diklat',
          model: 'k_tingkat_diklat_paud',
          type: 'select',
          default: false,
          props: ['attach'],
          master: this.$mapForMaster(this.masters.m_tingkat_diklat_paud || {}),
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        });

        temp.push({
          label: 'Pilih Peran',
          model: 'peran',
          type: 'select',
          default: true,
          props: ['attach'],
          master: [
            {
              text: 'Pengajar Inti',
              value: 'is_inti_ppm',
            },
            {
              text: 'Pembimbing Inti',
              value: 'is_inti_pptm',
            },
            {
              text: 'Lulus Bimtek Pengajar',
              value: 'is_bimtek_ppm',
            },
            {
              text: 'Lulus Bimtek Pembimbing',
              value: 'is_bimtek_pptm',
            },
            {
              text: 'Master',
              value: 'is_master',
            },
            {
              text: 'Tambahan',
              value: 'is_tambahan',
            },
          ],
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        });

        temp.push({
          label: 'Pendidikan Terkahir',
          model: 'k_kualifikasi',
          type: 'select',
          default: true,
          props: ['attach'],
          master: [
            {
              text: 'SMA Sederajat',
              value: 3,
            },
            {
              text: 'S1',
              value: 9,
            },
            {
              text: 'S2',
              value: 10,
            },
            {
              text: 'S3',
              value: 11,
            },
          ],
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        });
        temp.push({
          label: 'Pilih Jenis Diklat',
          default: true,
          type: 'select',
          model: 'petugas_paud',
          master: [
            { text: 'Melaksanakan Diklat Daring', value: 1 },
            { text: 'Melaksanakan Diklat Luring', value: 2 },
            { text: 'Melaksanakan Daring & Luring', value: 3 },
            { text: 'Belum Melaksanakan', value: 4 },
          ],
          props: ['attach'],
          grid: { cols: 12, md: 6 },
        });
      }

      return temp;
    },

    filtersMaster() {
      return {
        is_aktif: this.mAktif,
        instansi_id: this.initInstansis || {},
        k_propinsi: this.masters.m_propinsi || {},
        k_kota: this.masters.m_kota || {},
        k_diklat_paud: this.masters.m_diklat_paud || {},
        k_tingkat_diklat_paud: this.masters.m_tingkat_diklat_paud || {},
        k_kualifikasi: this.masters.m_kualifikasi || {},
        peran: {
          is_tambahan: 'Tambahan',
          is_inti_ppm: 'Pengajar Inti',
          is_inti_pptm: 'Pembimbing Inti',
          is_bimtek_ppm: 'Lulus Bimtek Pengajar',
          is_bimtek_pptm: 'Lulus Bimtek Pembimbing',
          is_master: 'Master',
        },
        petugas_paud: {
          1: 'Melaksanakan Diklat Daring',
          2: 'Melaksanakan Diklat Luring',
          3: 'Melaksananan Daring & Luring',
          4: 'Belum Melaksanakan',
        },
      };
    },

    kGroup() {
      return this.$route.meta.k_group;
    },
  },
  created() {
    // this.getGroups();
    this.getMasters({
      name: ['m_propinsi', 'm_kota', 'm_kualifikasi', 'm_golongan', 'm_diklat_paud', 'm_tingkat_diklat_paud'].join(';'),
      filter: {
        0: {
          k_propinsi: {
            op: '<',
            val: 90,
          },
        },
      },
    });

    if (['program', 'admin_gtk'].includes(this.jenis)) {
      this.getInstansi('', { count: 500 }, true);
    }
  },
  methods: {
    allow(action, data) {
      let disabled = false;
      switch (action.event) {
        case 'onAktif':
          disabled = !Number(this.$getDeepObj(data, 'is_aktif') || 0);
          break;
        case 'onNonAktif':
          disabled = Boolean(Number(this.$getDeepObj(data, 'is_aktif') || 0));
          break;
        case 'onResetIntiPpm':
          disabled =
            this.$allow('akun-pengajar.reset-status') && Number(this.$getDeepObj(data, 'is_inti_ppm') || 0) === 1;
          break;
        case 'onResetIntiPptm':
          disabled =
            this.$allow('akun-pengajar.reset-status') && Number(this.$getDeepObj(data, 'is_inti_pptm') || 0) === 1;
          break;
        case 'onResetBimtek':
          disabled =
            this.$allow('akun-pengajar.reset-status') && Number(this.$getDeepObj(data, 'is_bimtek_ppm') || 0) === 1;
          break;
        case 'onResetBimtekPptm':
          disabled =
            this.$allow('akun-pengajar.reset-status') && Number(this.$getDeepObj(data, 'is_bimtek_pptm') || 0) === 1;
          break;
        case 'onResetTambahan':
          disabled =
            this.$allow('akun-pengajar.reset-status') &&
            Number(this.$getDeepObj(data, 'is_tambahan') || 0) === 0 &&
            Number(this.$getDeepObj(data, 'instansi_id')) !== 800006;
          break;
        case 'onResetMaster':
          disabled =
            this.$allow('akun-pengajar.reset-status') && Number(this.$getDeepObj(data, 'is_master_ppm') || 0) === 1;
          break;
        default:
          disabled = this.$allow(action.akses, data.policies || false);
          break;
      }
      return disabled;
    },
  },
};
</script>
